import * as React from 'react';
import { init } from './services/bootstrap/init-app';
import App from './components/App';

init(App);
